import r from "../managers/braze-instance.js";
import v from "../common/event-logger.js";
import { logger as E, EventTypes as f } from "../../shared-lib/index.js";
import ot from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
import {
  validateCustomProperties as nt,
  validateCustomString as mt,
} from "../util/validation-utils.js";
import { CoreStrings as z } from "../common/constants.js";
export function logCustomEvent(t, e) {
  if (!r.rr()) return !1;
  if (null == t || t.length <= 0)
    return (
      E.error(
        `logCustomEvent requires a non-empty eventName, got "${t}". Ignoring event.`,
      ),
      !1
    );
  if (!mt(t, "log custom event", "the event name")) return !1;
  const [o, n] = nt(
    e,
    z.$e,
    "eventProperties",
    `log custom event "${t}"`,
    "event",
  );
  if (!o) return !1;
  const i = r.l();
  if (i && i.Ce(t))
    return E.info(`Custom Event "${t}" is blocklisted, ignoring.`), !1;
  const s = v.lt(f.CustomEvent, { n: t, p: n });
  if (s.W) {
    E.info(`Logged custom event "${t}".`);
    for (const o of s.Ee) rt.o().he(ot.xe, [t, e], o);
  }
  return s.W;
}
